export const COMPANY_NAME = 'Dragon Metalworks';
export const COMPANY_DOMAIN = 'dragonmetalworks.co.uk';
export const COMPANY_EMAIL = `info@${COMPANY_DOMAIN}`;

